import { useCallback, useEffect, useRef, useState } from 'react'
import { getGlobalChat } from '../services/globalChats'

// Caches full Global Search chat documents by id for the grid. Grid windows
// persist only `entityId`, so on reload we fetch any chats we don't already have.
// Callers can `seed` a chat they already hold (e.g. from the sidebar) to skip the
// fetch, and `remove` one after deletion. Fetches are de-duped per id. Mirrors
// useSearchroomCache. (Fetching is a no-op until the backend exists.)
export function useGlobalChatCache(entityIds) {
  const [chatsById, setChatsById] = useState({})
  const pendingRef = useRef(new Set())

  useEffect(() => {
    entityIds.forEach((id) => {
      if (!id || chatsById[id] || pendingRef.current.has(id)) return
      pendingRef.current.add(id)
      getGlobalChat(id)
        .then((chat) => chat && setChatsById((prev) => ({ ...prev, [id]: chat })))
        .catch(() => {})
        .finally(() => pendingRef.current.delete(id))
    })
  }, [entityIds, chatsById])

  const seed = useCallback((chat) => {
    if (chat?._id) setChatsById((prev) => ({ ...prev, [chat._id]: chat }))
  }, [])

  const remove = useCallback((id) => {
    setChatsById((prev) => {
      if (!(id in prev)) return prev
      const next = { ...prev }
      delete next[id]
      return next
    })
  }, [])

  return { chatsById, seed, remove }
}
